<template>
    <div>
        <div id="navigationPlaceholder" style="padding-top: 80px;">
            <AdminNavigationV2 v-if="organizationUnitId" :tid="organizationUnitId"></AdminNavigationV2>
        </div>

        <div class="container">
            <div class="row">
                <div class="col-lg-7">
                    <h1 style="font-size: 2em; font-weight: 300; color: #33475b;">Manage user's workspaces</h1>

                    <a :href="`/#/admin/organizations/users/manage/${id}`" class="btn btn-link btn-sm">
                        <i class="fa fa-arrow-left" aria-hidden="true"></i>
                        <span>Back</span>
                    </a>
                </div>
            </div>
        </div>

        <hr style="border-color: #bbb; margin: 20px 0 30px;" />

        <div class="container">
            <h4 v-if="organizationWorkspacesLoaded && organizationWorkspacesLength==0">No workspaces available</h4>

            <div v-if="userNotInWorkspaces.length" style="margin-bottom: 40px;">
                <h4 class="fg-color-blue">Invite user to workspaces</h4>
                <br />
                <div class="row">
                    <div v-for="w in userNotInWorkspaces" class="col-sm-6" style="margin-bottom: 20px;">
                        <div class="card bg-light">
                            <div class="card-header">
                                Workspace invitation
                                <button @click="handleAddUserToWorkspaceCommandV1(w)" class="btn btn-primary btn-sm pull-right">
                                    Send <i class="fa fa-send-o" aria-hidden="true"></i>
                                </button>
                            </div>
                            <div class="card-body">
                                <h5 class="card-title">{{w.Name}}</h5>
                                <p class="card-text"><em>{{w.Decription}}</em></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="userInWorkspaces.length">
                <h4 class="fg-color-blue">User's workspaces</h4>
                <br />

                <table class="table table-striped table-hover">
                    <tbody>
                        <tr v-for="w in userInWorkspaces">
                            <th>{{w.Name}}</th>
                            <th>{{w.Decription}}</th>
                            <td>
                                <button @click="handleRemoveUserFromWorkspaceCommandV1(w)" class="btn btn-secondary btn-sm pull-right">
                                    Remove an access
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
    import Component, { mixins } from 'vue-class-component';
    import PageBase from "@common/PageBase";
    import PageStatus from "@common/PageStatus";
    import Queries from "@Organizations/Users/Domain/queries-vue-component";
    import WorkspacesQueries from "@Organizations/Workspaces/Domain/queries-vue-component";
    import WorkspacesCommands from "@Organizations/Workspaces/Domain/commands-vue-component";
    import "@common/AdminNavigationV2.vue";

    @Component({
        watch: {
            organizationUnitId: 'organizationUnitIdChanged'
        }
    })
    export default class ManageUserWorkspacesPage extends mixins(PageBase, PageStatus, Queries, WorkspacesQueries, WorkspacesCommands) {
        mounted() {
            this.setTitle("Manage user's workspaces");
            this.runCurrentUserQueryV1(false, true, false);
            this.runUserQueryV1(this.id);
            this.runWorkspacesByUserQueryV1(this.id);
        }

        get userSessionDetails() { return this.model?.UserSessionDetails; }
        get userWithSensitiveDataModel() { return this.model?.UserWithSensitiveData; }
        get userWorkspacesModel() { return this.model?.UserWorkspaces; }
        get organizationWorkspacesModel() { return this.model?.OrganizationWorkspaces; }

        get user() { return this.userWithSensitiveDataModel; }
        get email() { return this.user?.Email; }
        get organizationUnitId() { return this.user?.OrganizationUnitId; }
        get userWorkspaces() { return this.userWorkspacesModel?.Workspaces || []; }
        get organizationWorkspaces() { return this.organizationWorkspacesModel?.Workspaces || []; }
        get organizationWorkspacesLoaded() { return this.organizationWorkspacesModel != null; }
        get organizationWorkspacesLength() { return this.organizationWorkspaces.length; }

        get workspaces() {
            return this.organizationWorkspaces.map(_ => Object.assign({}, _, {
                Exists: this.userWorkspaces.find(__ => __.WorkspaceId == _.WorkspaceId) != null
            }));
        }

        get userInWorkspaces() { return this.workspaces.filter(_ => _.Exists); }
        get userNotInWorkspaces() { return this.workspaces.filter(_ => !_.Exists); }

        succeedAnyCommand(status) {
            this.runWorkspacesByUserQueryV1(this.id);
        }

        handleAddUserToWorkspaceCommandV1(workspace) {
            this.invokeAddUserToWorkspaceCommandV1(workspace.WorkspaceId, this.id);
        }

        handleRemoveUserFromWorkspaceCommandV1(workspace) {
            if (confirm(`Do you want to remove user ${this.email} from workspace?`))
                this.invokeRemoveUserFromWorkspaceCommandV1(workspace.WorkspaceId, this.id);
        }

        //@Watch('organizationUnitId')
        organizationUnitIdChanged(organizationUnitId) {
            if (organizationUnitId) {
                this.runWorkspacesByOrganizationQueryV1(organizationUnitId);
            }
        }
    }
</script>